import {formatDateOnly} from '../dates';
import {Link} from '../ui/ScopedLink';
import {DataTable} from '../ui/DataTable';
import {StatusBadge} from '../ui/StatusBadge';
import type {Relationship} from './BuildingPeople';

export function BuildingContactTable({rows,building,pageSize=18}:{rows:Relationship[];building:string;pageSize?:number}){
 return <DataTable compact caption={<span className="sr-only">Recorded building contact relationships</span>} scrollLabel="Building contact relationships" rows={rows} pageSize={pageSize} getRowKey={row=>row.relationship_id}
 rowHeader={{id:'name',header:'Name',render:row=>row.party_id?<Link className="data-table__record-link" to={'/records/'+row.party_type.toLowerCase()+'/'+row.party_id+'?building='+building}>{row.party_name||'Name not recorded'}</Link>:row.party_name||'Name not recorded'}}
 columns={[
  {id:'type',header:'Record type',render:row=>row.party_type},
  {id:'role',header:'Relationship',render:row=>row.role},
  {id:'premises',header:'Applies to',render:row=>row.premises.length?row.premises.join(', '):'Building'},
  {id:'status',header:'Recorded status',render:row=><span title={(row.start_date?'Start '+formatDateOnly(row.start_date):'Start not recorded')+' · '+(row.end_date?'Ends '+formatDateOnly(row.end_date):'No end recorded')}><StatusBadge text={row.status||'Not recorded'}/></span>},

 ]}/>;
}
